export default __webpack_public_path__ + "static/media/reno.9af94c36.jpg";